import {useProductContext} from 'contexts';
import {Dispatch, SetStateAction, useEffect, useRef} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useGetQFPProductStructureQuery} from 'components/customer/Product/store/productApi';

export const useAutoChangeTabOnError = () => {
    const [searchParams] = useSearchParams();
    const {setCurrentTab} = useProductContext<{
        setCurrentTab: Dispatch<SetStateAction<number>>;
    }>();

    const productType = searchParams.get('product');
    const cabinetId = searchParams.get('cabinetId');

    const productTypeRef = useRef(productType);
    const cabinetIdRef = useRef(cabinetId);

    const {data} = useGetQFPProductStructureQuery(
        {cabinetType: parseInt(productType)},
        {skip: productType == undefined || productType == ''}
    );

    useEffect(() => {
        const productType = searchParams.get('product');
        const cabinetId = searchParams.get('cabinetId');

        if (
            productType != productTypeRef.current ||
            cabinetId != cabinetIdRef.current
        ) {
            productTypeRef.current = productType;
            cabinetIdRef.current = cabinetId;

            // this is so when product is switched when one of them is open,
            // take customer to first tab.
            setCurrentTab(0);
        }
    }, [searchParams]);

    useEffect(() => {
        if (data) {
            const hasError = searchParams.has('error');
            const errorType = searchParams.get('error');
            const isEditing = searchParams.has('cabinetId');

            if (isEditing && hasError && errorType == 'shelf-error') {
                const {hasDoors, hasDrawers, hasShelves} = data;

                if (hasShelves) {
                    if (hasDoors && hasDrawers) {
                        setCurrentTab(4);
                    } else if (
                        (hasDoors && !hasDrawers) ||
                        (!hasDoors && hasDrawers)
                    ) {
                        setCurrentTab(3);
                    } else {
                        setCurrentTab(2);
                    }
                }
            }
        }
    }, [data]);
};
